import { useState } from "react";
import { Button, Textarea, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconSend } from "@tabler/icons-react";

export default function PcAlertModal({ context, id, innerProps }) {
  const [loading, setLoading] = useState(false);
  const onSend = innerProps.onSend;

  const form = useForm({
    initialValues: {
      title: "",
      message: "",
    },
    validate: {
      title: (value) => (value.trim().length === 0 ? "Zadej titulek." : null),
      message: (value) => (value.trim().length === 0 ? "Zadej zprávu." : null),
    },
  });

  async function handleSubmit(values) {
    setLoading(true);
    try {
      await onSend({ title: values.title.trim(), message: values.message.trim() });
      context.closeModal(id);
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <TextInput
        label="Titulek"
        placeholder="Pozor všichni!"
        mb="sm"
        data-autofocus
        {...form.getInputProps("title")}
      />
      <Textarea
        label="Zpráva"
        placeholder="Plňte questy!"
        minRows={3}
        maxRows={10}
        autosize
        mb="sm"
        {...form.getInputProps("message")}
      />

      <Button fullWidth type="submit" loading={loading} mt="sm" leftSection={<IconSend size={18} stroke={1.5} />}>
        Odeslat alert
      </Button>
    </form>
  );
}
